import { ActivityIndicator, StyleSheet, View } from 'react-native';

import { colors } from '@/constants/theme';

/**
 * Full-screen spinner shown while authStore.hydrate() is loading the
 * session token from storage. Auth-gated layouts must render this
 * instead of redirecting while `!authStore.hydrated` — on web, a
 * cold load at a deep link (e.g. /leaderboard) briefly looks
 * logged-out, and redirecting on that first frame bounces the user
 * to login and loses the URL.
 */
export function HydrationSplash() {
  return (
    <View style={styles.splash}>
      <ActivityIndicator color={colors.electricGreen} size="large" />
    </View>
  );
}

const styles = StyleSheet.create({
  splash: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.deepGreen,
  },
});
